<template>
  <div>
    <div class="tooth-wrap">
      <!-- <div class="radio-wrap" @change="changeBridge" v-if="!isShow&&subCatalogId!='1010410'"> -->
      <div class="radio-wrap" @change="changeBridge" v-if="!isShow">
        <el-radio v-model="isBridge" :label="false" v-if="servBridge&&subCatalogId!='1010510'">单冠</el-radio>
        <el-radio v-model="isBridge" :label="true" v-if="servBridge">连桥</el-radio>
      </div>
      <table style="margin:0 auto;">
        <tbody>
          <tr>
          <td></td>
          <div>
            <div ref="018" :class="metalPlatForm.includes(18) ? 'bridge-col-add':'bridge-col-zero'" style="float:left;width:6.75%;" v-if="metalPlatForm.includes(18)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="018" :class="metalPlatForm2.includes(18) ? 'bridge-col-add':'bridge-col-zero'" style="float:left;width:6.75%;" v-else>
            	<i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
            <div ref="017" :class="metalPlatForm.includes(17) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:6.5%;" v-if="metalPlatForm.includes(17)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="017" :class="metalPlatForm2.includes(17) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:6.5%;" v-else>
            	  <i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
            <div ref="016" :class="metalPlatForm.includes(16) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:7.65%;" v-if="metalPlatForm.includes(16)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="016" :class="metalPlatForm2.includes(16) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:7.65%;" v-else>
            	 <i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
            <div ref="015" :class="metalPlatForm.includes(15) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:5.5%;" v-if="metalPlatForm.includes(15)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="015" :class="metalPlatForm2.includes(15) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:5.5%;" v-else>
          	  <i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
            <div ref="014" :class="metalPlatForm.includes(14) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:5.25%;" v-if="metalPlatForm.includes(14)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="014" :class="metalPlatForm2.includes(14) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:5.25%;" v-else>
          	  <i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
            <div ref="013" :class="metalPlatForm.includes(13) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:6.25%;" v-if="metalPlatForm.includes(13)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="013" :class="metalPlatForm2.includes(13) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:6.25%;" v-else>
          	  <i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
            <div ref="012" :class="metalPlatForm.includes(12) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:5%;" v-if="metalPlatForm.includes(12)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="012" :class="metalPlatForm2.includes(12) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:5%;" v-else>
          	  <i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
            <div ref="011" :class="metalPlatForm.includes(11) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:7%;" v-if="metalPlatForm.includes(11)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="011" :class="metalPlatForm2.includes(11) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:7%;" v-else>
          	  <i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
            <div ref="021" :class="metalPlatForm.includes(21) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:7.5%;" v-if="metalPlatForm.includes(21)">
          	  <i class="el-icon-s-help lab-cen" style="margin-left: 40%;"></i>
            </div>
            <div ref="021" :class="metalPlatForm2.includes(21) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:7.5%;" v-else>
          	  <i class="el-icon-s-help lab-cen porcelain"  style="margin-left: 40%;"></i>
            </div>
            <div ref="022" :class="metalPlatForm.includes(22) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:4.75%;" v-if="metalPlatForm.includes(22)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="022" :class="metalPlatForm2.includes(22) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:4.75%;" v-else>
          	  <i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
            <div ref="023" :class="metalPlatForm.includes(23) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:6.25%;" v-if="metalPlatForm.includes(23)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="023" :class="metalPlatForm2.includes(23) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:6.25%;" v-else>
          	  <i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
            <div ref="024" :class="metalPlatForm.includes(24) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:5.5%;" v-if="metalPlatForm.includes(24)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="024" :class="metalPlatForm2.includes(24) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:5.5%;" v-else>
          	  <i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
            <div ref="025" :class="metalPlatForm.includes(25) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:5.25%;" v-if="metalPlatForm.includes(25)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="025" :class="metalPlatForm2.includes(25) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:5.25%;" v-else>
          	  <i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
            <div ref="026" :class="metalPlatForm.includes(26) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:7.5%;" v-if="metalPlatForm.includes(26)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="026" :class="metalPlatForm2.includes(26) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:7.5%;" v-else>
          	  <i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
            <div ref="027" :class="metalPlatForm.includes(27) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:7%;" v-if="metalPlatForm.includes(27)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="027" :class="metalPlatForm2.includes(27) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:7%;" v-else>
          	  <i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
            <div ref="028" :class="metalPlatForm.includes(28) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:6.25%;" v-if="metalPlatForm.includes(28)">
          	  <i class="el-icon-s-help lab-cen"></i>
            </div>
            <div ref="028" :class="metalPlatForm2.includes(28) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;float:left;width:6.25%;" v-else>
          	  <i class="el-icon-s-help lab-cen porcelain"></i>
            </div>
          </div>
          <td></td>
          </tr>
          <tr>
            <td></td>
            <div>
              <div ref="018" :class="bridgeList.includes(18) ? 'bridge-col':''" style="height: 2px;float:left;width:6.75%;"> </div>
              <div ref="017" :class="bridgeList.includes(17) ? 'bridge-col':''" style="height: 2px;float:left;width:6.5%;"></div>
              <div ref="016" :class="bridgeList.includes(16) ? 'bridge-col':''" style="height: 2px;float:left;width:7.65%;"></div>
              <div ref="015" :class="bridgeList.includes(15) ? 'bridge-col':''" style="height: 2px;float:left;width:5.5%;"></div>
              <div ref="014" :class="bridgeList.includes(14) ? 'bridge-col':''" style="height: 2px;float:left;width:5.25%;"></div>
              <div ref="013" :class="bridgeList.includes(13) ? 'bridge-col':''" style="height: 2px;float:left;width:6.25%;"></div>
              <div ref="012" :class="bridgeList.includes(12) ? 'bridge-col':''" style="height: 2px;float:left;width:5%;"></div>
              <div ref="011" :class="bridgeList.includes(11) ? 'bridge-col':''" style="height: 2px;float:left;width:7%;"></div>
              <div ref="021" :class="bridgeList.includes(21) ? 'bridge-col':''" style="height: 2px;float:left;width:7.5%;"></div>
              <div ref="022" :class="bridgeList.includes(22) ? 'bridge-col':''" style="height: 2px;float:left;width:4.75%;"></div>
              <div ref="023" :class="bridgeList.includes(23) ? 'bridge-col':''" style="height: 2px;float:left;width:6.25%;"></div>
              <div ref="024" :class="bridgeList.includes(24) ? 'bridge-col':''" style="height: 2px;float:left;width:5.5%;"></div>
              <div ref="025" :class="bridgeList.includes(25) ? 'bridge-col':''" style="height: 2px;float:left;width:5.25%;"></div>
              <div ref="026" :class="bridgeList.includes(26) ? 'bridge-col':''" style="height: 2px;float:left;width:7.5%;"></div>
              <div ref="027" :class="bridgeList.includes(27) ? 'bridge-col':''" style="height: 2px;float:left;width:7%;"></div>
              <div ref="028" :class="bridgeList.includes(28) ? 'bridge-col':''" style="height: 2px;float:left;width:6.25%;"></div>
            </div>
            <td></td>
          </tr>
          <tr>
            <td style="padding:0 30px;font-size: 18px;">R</td>
            <td>
              <table :class="isShow ? 'tooth-table-show' : 'tooth-table'" cellspace="0">
                <tbody>
                  <tr>
                    <td style="float:right;padding-bottom:5px;padding-right:5px;white-space: nowrap;">
                      <img ref='18' id="18"
                        :src="'/static/images/tooth/18' + (activeList.includes(18) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(18) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='17' id="17"
                        :src="'/static/images/tooth/17' + (activeList.includes(17) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(17) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='16' id="16"
                        :src="'/static/images/tooth/16' + (activeList.includes(16) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(16) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='15' id="15"
                        :src="'/static/images/tooth/15' + (activeList.includes(15) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(15) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='14' id="14"
                        :src="'/static/images/tooth/14' + (activeList.includes(14) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(14) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='13' id="13"
                        :src="'/static/images/tooth/13' + (activeList.includes(13) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(13) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='12' id="12"
                        :src="'/static/images/tooth/12' + (activeList.includes(12) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(12) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='11' id="11"
                        :src="'/static/images/tooth/11' + (activeList.includes(11) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(11) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                    </td>
                    <td style="width:1px;background:#808080;"></td>
                    <td style="float:left; padding-bottom:5px;padding-left:5px;white-space: nowrap;">
                      <img ref='21' id="21"
                        :src="'/static/images/tooth/21' + (activeList.includes(21) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(21) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='22' id="22"
                        :src="'/static/images/tooth/22' + (activeList.includes(22) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(22) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='23' id="23"
                        :src="'/static/images/tooth/23' + (activeList.includes(23) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(23) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='24' id="24"
                        :src="'/static/images/tooth/24' + (activeList.includes(24) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(24) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='25' id="25"
                        :src="'/static/images/tooth/25' + (activeList.includes(25) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(25) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='26' id="26"
                        :src="'/static/images/tooth/26' + (activeList.includes(26) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(26) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='27' id="27"
                        :src="'/static/images/tooth/27' + (activeList.includes(27) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(27) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='28' id="28"
                        :src="'/static/images/tooth/28' + (activeList.includes(28) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(28) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                    </td>
                  </tr>
                  <tr>
                    <td colspan="167" style="height:1px;background:#808080;"></td>
                  </tr>
                  <tr>
                    <td style="float:right;padding-top:5px; padding-right:5px;white-space: nowrap;">
                      <img ref='48' id="48"
                        :src="'/static/images/tooth/48' + (activeList.includes(48) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(48) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='47' id="47"
                        :src="'/static/images/tooth/47' + (activeList.includes(47) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(47) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='46' id="46"
                        :src="'/static/images/tooth/46' + (activeList.includes(46) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(46) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='45' id="45"
                        :src="'/static/images/tooth/45' + (activeList.includes(45) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(45) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='44' id="44"
                        :src="'/static/images/tooth/44' + (activeList.includes(44) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(44) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='43' id="43"
                        :src="'/static/images/tooth/43' + (activeList.includes(43) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(43) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='42' id="42"
                        :src="'/static/images/tooth/42' + (activeList.includes(42) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(42) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='41' id="41"
                        :src="'/static/images/tooth/41' + (activeList.includes(41) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(41) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                    </td>
                    <td style="width:1px;background:#808080;"></td>
                    <td style="float:left; padding-top:5px;padding-left:5px;white-space: nowrap;">
                      <img ref='31' id="31"
                        :src="'/static/images/tooth/31' + (activeList.includes(31) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(31) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='32' id="32"
                        :src="'/static/images/tooth/32' + (activeList.includes(32) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(32) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='33' id="33"
                        :src="'/static/images/tooth/33' + (activeList.includes(33) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(33) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='34' id="34"
                        :src="'/static/images/tooth/34' + (activeList.includes(34) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(34) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='35' id="35"
                        :src="'/static/images/tooth/35' + (activeList.includes(35) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(35) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='36' id="36"
                        :src="'/static/images/tooth/36' + (activeList.includes(36) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(36) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='37' id="37"
                        :src="'/static/images/tooth/37' + (activeList.includes(37) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(37) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">
                      <img ref='38' id="38"
                        :src="'/static/images/tooth/38' + (activeList.includes(38) ? '_active' : '') + '.png'"
                        :class="bridgeList.includes(38) ? 'tooth-bridge' : 'tooth-single'" @click="shiftClickTooth($event)">

                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td style="padding:0 30px;font-size: 18px;">L</td>
          </tr>
          <tr>
            <td></td>
            <div style="height: 10px;">
              <div id="null" style="height: 10px;width:3.55%;float:left;"></div>
              <div ref="048" :class="bridgeList.includes(48) ? 'bridge-col':''" style="height: 2px;width:6.4%;float:left;"></div>
              <div ref="047" :class="bridgeList.includes(47) ? 'bridge-col':''" style="height: 2px;width:7.3%;float:left;"></div>
              <div ref="046" :class="bridgeList.includes(46) ? 'bridge-col':''" style="height: 2px;width:8.2%;float:left;"></div>
              <div ref="045" :class="bridgeList.includes(45) ? 'bridge-col':''" style="height: 2px;width:5%;float:left;"></div>
              <div ref="044" :class="bridgeList.includes(44) ? 'bridge-col':''" style="height: 2px;width:5%;float:left;"></div>
              <div ref="043" :class="bridgeList.includes(43) ? 'bridge-col':''" style="height: 2px;width:5.4%;float:left;"></div>
              <div ref="042" :class="bridgeList.includes(42) ? 'bridge-col':''" style="height: 2px;width:4.3%;float:left;"></div>
              <div ref="041" :class="bridgeList.includes(41) ? 'bridge-col':''" style="height: 2px;width:4.75%;float:left;"></div>
              <div ref="031" :class="bridgeList.includes(31) ? 'bridge-col':''" style="height: 2px;width:5%;float:left;"></div>
              <div ref="032" :class="bridgeList.includes(32) ? 'bridge-col':''" style="height: 2px;width:4.3%;float:left;"></div>
              <div ref="033" :class="bridgeList.includes(33) ? 'bridge-col':''" style="height: 2px;width:5.3%;float:left;"></div>
              <div ref="034" :class="bridgeList.includes(34) ? 'bridge-col':''" style="height: 2px;width:5%;float:left;"></div>
              <div ref="035" :class="bridgeList.includes(35) ? 'bridge-col':''" style="height: 2px;width:5.1%;float:left;"></div>
              <div ref="036" :class="bridgeList.includes(36) ? 'bridge-col':''" style="height: 2px;width:8.2%;float:left;"></div>
              <div ref="037" :class="bridgeList.includes(37) ? 'bridge-col':''" style="height: 2px;width:7.25%;float:left;"></div>
              <div ref="038" :class="bridgeList.includes(38) ? 'bridge-col':''" style="height: 2px;width:6.4%;float:left;"></div>
              <div id="null" style="height: 10px;width:3.55%;float:left;"></div>
            </div>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <div style="height: 10px;">
              <div id="null" style="height: 10px;width:3.55%;float:left;"></div>
              <div ref="048" :class="metalPlatForm.includes(48) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:6.4%;float:left;" v-if="metalPlatForm.includes(48)">
          		<i class="el-icon-s-help lab-cen"></i>
          	</div>
              <div :class="metalPlatForm2.includes(48) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:6.4%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div :class="metalPlatForm.includes(47) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:7.3%;float:left;" v-if="metalPlatForm.includes(47)">
          		<i class="el-icon-s-help lab-cen"></i>
          	</div>
              <div :class="metalPlatForm2.includes(47) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:7.3%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div :class="metalPlatForm.includes(46) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:8.2%;float:left;" v-if="metalPlatForm.includes(46)">
          		<i class="el-icon-s-help lab-cen"></i>
          	</div>
              <div :class="metalPlatForm2.includes(46) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:8.2%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div :class="metalPlatForm.includes(45) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:5%;float:left;" v-if="metalPlatForm.includes(45)">
          		<i class="el-icon-s-help lab-cen" style="margin-left: 23%;"></i>
          	</div>
              <div :class="metalPlatForm2.includes(45) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:5%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain" style="margin-left: 23%;"></i>
          	</div>
              <div :class="metalPlatForm.includes(44) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:5%;float:left;" v-if="metalPlatForm.includes(44)">
          		<i class="el-icon-s-help lab-cen"></i>
          	</div>
              <div :class="metalPlatForm2.includes(44) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:5%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div ref="043" :class="metalPlatForm.includes(43) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:5.4%;float:left;" v-if="metalPlatForm.includes(43)">
          		<i class="el-icon-s-help lab-cen"></i>
          	</div>
              <div :class="metalPlatForm2.includes(43) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:5.4%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div :class="metalPlatForm.includes(42) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:4.3%;float:left;" v-if="metalPlatForm.includes(42)">
          		<i class="el-icon-s-help lab-cen"></i>
          	</div>
              <div :class="metalPlatForm2.includes(42) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:4.3%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div :class="metalPlatForm.includes(41) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:4.75%;float:left;" v-if="metalPlatForm.includes(41)">
          		<i class="el-icon-s-help lab-cen" style="margin-left: 30%;"></i>
          	</div>
              <div :class="metalPlatForm2.includes(41) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:4.75%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div :class="metalPlatForm.includes(31) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:5%;float:left;" v-if="metalPlatForm.includes(31)">
          		<i  class="el-icon-s-help lab-cen" style="margin-left: 35%;"></i>
          	</div>
              <div :class="metalPlatForm2.includes(31) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:5%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div :class="metalPlatForm.includes(32) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:4.3%;float:left;" v-if="metalPlatForm.includes(32)">
          		<i class="el-icon-s-help lab-cen"></i>
          	</div>
              <div :class="metalPlatForm2.includes(32) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:4.3%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div :class="metalPlatForm.includes(33) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:5.3%;float:left;" v-if="metalPlatForm.includes(33)">
          		<i class="el-icon-s-help lab-cen"></i>
          	</div>
              <div :class="metalPlatForm2.includes(33) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:5.3%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div :class="metalPlatForm.includes(34) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:5%;float:left;" v-if="metalPlatForm.includes(34)">
          		<i class="el-icon-s-help lab-cen"></i>
          	</div>
              <div :class="metalPlatForm2.includes(34) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:5%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div :class="metalPlatForm.includes(35) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:5.1%;float:left;" v-if="metalPlatForm.includes(35)">
          		<i class="el-icon-s-help lab-cen"></i>
          	</div>
              <div :class="metalPlatForm2.includes(35) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:5.1%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div :class="metalPlatForm.includes(36) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:8.2%;float:left;" v-if="metalPlatForm.includes(36)">
          		<i class="el-icon-s-help lab-cen"></i>
          	</div>
              <div :class="metalPlatForm2.includes(36) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:8.2%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div :class="metalPlatForm.includes(37) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:7.25%;float:left;" v-if="metalPlatForm.includes(37)">
          		<i class="el-icon-s-help lab-cen"></i>
          	</div>
              <div :class="metalPlatForm2.includes(37) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:7.25%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div :class="metalPlatForm.includes(38) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:6.4%;float:left;" v-if="metalPlatForm.includes(38)">
          		<i class="el-icon-s-help lab-cen"></i>
          	</div>
              <div :class="metalPlatForm2.includes(38) ? 'bridge-col-add':'bridge-col-zero'" style="height: 2px;width:6.4%;float:left;" v-else>
          		<i class="el-icon-s-help lab-cen porcelain"></i>
          	</div>
              <div id="null" style="height: 10px;width:3.55%;float:left;"></div>
            </div>
            <td></td>
          </tr>
        </tbody>
      </table>
      <div class="button-wrap" style="margin-top: -5px;" v-if="!isShow">
        <div class="button-add" style="margin-bottom: 15px;">
          <el-button type="primary" size="mini" round plain @click="addBridge" v-if="isBridge && tempList.length > 1">添加连桥
          </el-button>
          <el-button type="primary" class="btn-pos" size="mini" round plain @click="selectAll">全部选择</el-button>
        </div>
        <div class="button-clear" style="margin-bottom: 15px;">
          <el-button type="primary" size="mini" round plain @click="resetBridge"
            v-if="isBridge && activeBridgeList.length > 0">清除连桥</el-button>
          <el-button type="primary" class="btn-pos" size="mini" round plain @click="resetSingle"
            v-if="activeSingleList.length > 0 || metalPlatForm.length > 0 || metalPlatForm2.length > 0">全部清除</el-button>
        </div>
      </div>
    </div>
    <div>
    </div>
  </div>
</template>
<script>
import {
    ref
  } from 'vue'
  import {
    mapState
  } from 'vuex'
  export default {
    props: {
      bridgeDataList: {
        type: Array,
        default: null
      },
      singleDataList: {
        type: Array,
        default: null
      },
      isShow: {
        type: Boolean,
        default: false
      },
      subCatalogId:{
        type:String
      },
      options1:{
        type: Boolean,
        default: false
      },
      options2:{
        type: Boolean,
        default: false
      },
      options3:{
        type: Boolean,
        default: false
      },
      withoptionsId:{
        type:String,
      },
      servBridge:{//判断连桥显示
        type:Boolean,
        default:false
      },
      composite:{
        type:String,
        default:'0'
      },
      isCreate:{
        type:Boolean,
        default:false
      },
      checkFlag:{
        type:Boolean,
        default:false
      },
    },
    data() {
      return {
        isBridge: false,
        activeList: [], // 控制激活
        bridgeList: [], // 控制连桥激活
        tempList: [], // 连桥临时
        activeBridgeList: [], // 最终列表
        activeSingleList: [], // 最终列表
        bimaxillary: false	,//是否是双颌
        selAll:false,
        metalPlatForm:[],//基台(金属)列表
        metalPlatForm2:[],//基台(全瓷)列表
        shiftKeyPressed: false,
        firstKey: null,//shiftKey为true时按下的首个tooth
        endKey: null,//shiftKey为true时按下的末尾tooth
      }
    },
	computed: {
	  ...mapState(['common', 'user']),
    // 对应额外适应症侧边栏选中位置
    option1() {
      return this.options1;
    },
    option2() {
      return this.options2;
    },
    option3() {
      return this.options3;
    },
	},
  methods: {
    clickTooth(event) {
      // if(this.isCreate!=true){
      //   return false;
      // }
      var id = this.subCatalogId
      var flag1 = this.options1
      var flag2 = this.options2
      var flag3 = this.options3
      var list1 = this.metalPlatForm
      var list2 = this.metalPlatForm2
      if (this.isShow) {
        return false;
      }
      var toothId = event.currentTarget.id;
      if(this.firstKey!=null&&this.shiftKeyPressed){
        this.endKey = toothId
      }
      this.firstKey = this.endKey==null?toothId:this.firstKey
      if (this.isBridge) {
        // 连桥
        // 根据选择类型匹配选中牙位
        if(flag1&&flag2){
          // 上部冠+基台(金属)
          if(list2.includes(parseInt(toothId))){
            const index = list2.indexOf(parseInt(toothId))
            list2.splice(index,1)
          }
          if(list1.includes(parseInt(toothId))){
            const index = list1.indexOf(parseInt(toothId))
            list1.splice(index,1)
          }else{
            list1.push(parseInt(toothId))
          }
          this.addTempBridge(toothId);
        }else if(flag1&&flag3){
          // 上部冠+基台(全瓷)
          if(list1.includes(parseInt(toothId))){
            const index = list1.indexOf(parseInt(toothId))
            list1.splice(index,1)
          }
          if(list2.includes(parseInt(toothId))){
            const index = list2.indexOf(parseInt(toothId))
            list2.splice(index,1)
          }else{
            list2.push(parseInt(toothId))
          }
          this.addTempBridge(toothId);
        }else if(flag2){
          // 基台(金属)
          if(list2.includes(parseInt(toothId))){
            const index = list2.indexOf(parseInt(toothId))
            list2.splice(index,1)
          }
          if(list1.includes(parseInt(toothId))){
            const index = list1.indexOf(parseInt(toothId))
            list1.splice(index,1)
          }else{
            list1.push(parseInt(toothId))
          }
        }else if(flag3){
          // 上部冠+基台(全瓷)
          if(list1.includes(parseInt(toothId))){
            const index = list1.indexOf(parseInt(toothId))
            list1.splice(index,1)
          }
          if(list2.includes(parseInt(toothId))){
            const index = list2.indexOf(parseInt(toothId))
            list2.splice(index,1)
          }else{
            list2.push(parseInt(toothId))
          }
        }else{
          this.addTempBridge(toothId);
        }
      } else { // 单冠
        // 根据选择类型匹配选中牙位
        this.clickComposite(toothId);
      }
      this.$emit('select-tooth', this.activeSingleList, this.activeBridgeList,this.metalPlatForm,this.metalPlatForm2)
      //判断上下颌，上下颌的服务单类型单独计算价格
      this.calJaw()
    },
    // click添加复合适应症的牙位
    clickComposite(toothId){
      // 根据选择类型匹配选中牙位
      var id = this.subCatalogId
      var flag1 = this.options1
      var flag2 = this.options2
      var flag3 = this.options3
      var list1 = this.metalPlatForm
      var list2 = this.metalPlatForm2
      //当前服务为马泷桥
      if(id == '1010410'){
        // this.addSingle(toothId);
        if(this.option1){
          this.addSingle(toothId);
        }else{
          if(list2.includes(parseInt(toothId))){
            const index = list2.indexOf(parseInt(toothId))
            list2.splice(index,1)
          }
          if(list1.includes(parseInt(toothId))){
            const index = list1.indexOf(parseInt(toothId))
            list1.splice(index,1)
          }else{
            list1.push(parseInt(toothId))
          }
        }
      }else if(flag1&&flag2){
        // 复合适应症：上部冠+基台金属
        if(list1.includes(parseInt(toothId))&&!this.activeSingleList.includes(parseInt(toothId))){
          var str = this.activeBridgeList+''
          if(str.includes(toothId)){
            const index = list1.indexOf(parseInt(toothId))
            list1.splice(index,1)
          }else{
            this.addSingle(toothId);
          }
        }else if(list1.includes(parseInt(toothId))&&this.activeSingleList.includes(parseInt(toothId))){
          const index = list1.indexOf(parseInt(toothId))
          list1.splice(index,1)
          this.addSingle(toothId);
        }else if(!list1.includes(parseInt(toothId))&&!this.activeSingleList.includes(parseInt(toothId))){
          this.addSingle(toothId);
          list1.push(parseInt(toothId))
          if(list2.includes(parseInt(toothId))){
            const index = list2.indexOf(parseInt(toothId))
            list2.splice(index,1)
          }
        }else if(!list1.includes(parseInt(toothId))&&this.activeSingleList.includes(parseInt(toothId))){
          if(list2.includes(parseInt(toothId))){
            const index = list2.indexOf(parseInt(toothId))
            list2.splice(index,1)
          }
          list1.push(parseInt(toothId))
        }
      }else if(flag1&&flag3){
        // 复合适应症：上部冠+基台全瓷
        if(list2.includes(parseInt(toothId))&&!this.activeSingleList.includes(parseInt(toothId))){
          var str = this.activeBridgeList+''
          if(str.includes(toothId)){
            const index = list2.indexOf(parseInt(toothId))
            list2.splice(index,1)
          }else{
            this.addSingle(toothId);
          }
        }else if(list2.includes(parseInt(toothId))&&this.activeSingleList.includes(parseInt(toothId))){
          const index = list2.indexOf(parseInt(toothId))
          list2.splice(index,1)
          this.addSingle(toothId);
        }else if(!list2.includes(parseInt(toothId))&&!this.activeSingleList.includes(parseInt(toothId))){
          this.addSingle(toothId);
          list2.push(parseInt(toothId))
          if(list1.includes(parseInt(toothId))){
            const index = list1.indexOf(parseInt(toothId))
            list1.splice(index,1)
          }
        }else if(!list2.includes(parseInt(toothId))&&this.activeSingleList.includes(parseInt(toothId))){
          if(list1.includes(parseInt(toothId))){
            const index = list1.indexOf(parseInt(toothId))
            list1.splice(index,1)
          }
          list2.push(parseInt(toothId))
        }
      }else if(flag1&&!flag2&&!flag3){
        //上部冠
        this.addSingle(toothId);
      }else if(!flag1&&flag2&&!flag3){
        //基台(金属)
        if(list2.includes(parseInt(toothId))){
          const index = list2.indexOf(parseInt(toothId))
          list2.splice(index,1)
        }
        if(list1.includes(parseInt(toothId))){
          const index = list1.indexOf(parseInt(toothId))
          list1.splice(index,1)
        }else{
          list1.push(parseInt(toothId))
        }
      }else if(!flag1&&!flag2&&flag3){
        // 基台(全瓷)
        if(list1.includes(parseInt(toothId))){
          const index = list1.indexOf(parseInt(toothId))
          list1.splice(index,1)
        }
        if(list2.includes(parseInt(toothId))){
          const index = list2.indexOf(parseInt(toothId))
          list2.splice(index,1)
        }else{
          list2.push(parseInt(toothId))
        }
      }else{
        this.addSingle(toothId);
      }
    },
    // 添加单冠
    addSingle(toothId) {
      // if(this.isCreate!=true){
      //   return false;
      // }
      if (this.bridgeList.includes(parseInt(toothId))) {
        return false;
      }
      if (this.activeList.includes(parseInt(toothId))) {
        this.activeList.forEach((val, i) => {
          if (val === parseInt(toothId)) {
            this.activeList.splice(i, 1)
          }
        })
        // 同步处理 单冠
        this.activeSingleList.forEach((val, i) => {
          if (val === parseInt(toothId)||val === toothId) {
            this.activeSingleList.splice(i, 1)
            this.$refs[toothId].setAttribute('class','tooth-single')
          }
        })
      } else {
        this.activeList.push(parseInt(toothId));
        // 同步处理 单冠,如果list内没有toothid的int和str才执行
        if (!this.activeSingleList.includes(parseInt(toothId))&&!this.activeSingleList.includes(toothId)) {
          this.activeSingleList.push(parseInt(toothId));
        }
      }
      this.activeList.sort();
      this.activeSingleList.sort();
      // console.log("已选 --> " + this.activeList)
      // console.log("添加单冠 --> " + this.activeSingleList)
      // console.log("添加连桥 --> " + this.activeBridgeList);
    },
    addTempBridge(toothId) {
      if (this.tempList.includes(parseInt(toothId))) {
        this.$refs[toothId].setAttribute("class", "tooth-single");
        this.tempList.forEach((val, i) => {
          if (val === parseInt(toothId)) {
            this.tempList.splice(i, 1)
          }
        })
      } else {
        if (this.checkBridge(toothId)) {
          this.$refs[toothId].setAttribute("class", "tooth-select");
          this.tempList.push(parseInt(toothId));
        } else {
          if(this.subCatalogId == '1010210'||this.subCatalogId == '1010220'||this.selAll == true){
              this.$refs[toothId].setAttribute("class","tooth-select");
              this.tempList.push(parseInt(toothId));
          }else{
            if(this.shiftKeyPressed){
              this.$refs[toothId].setAttribute("class","tooth-select");
              this.tempList.push(parseInt(toothId));
            }else{
              this.$yxz.msg("请选择相邻牙位",'warning',3000,{
                customClass:'adv-message'
              })
            }
          }
        }
      }
    console.log("连桥临时 ---> " + this.tempList)
    },
    // 添加连桥
    addBridge() {
      let oldArr = this.activeBridgeList.flat();
      let flag = true
      oldArr.forEach((val)=>{
        if(this.tempList.includes(val)){
          flag = false
        }
      })
      if(flag){
        this.tempList.forEach((val, i) => {
          if(!this.activeList.includes(val)){
            this.activeList.push(val);
          }
          this.bridgeList.push(val);
        })
        this.activeBridgeList.push(this.tempList); //二维数组
        if(this.option2){
          this.tempList.forEach(item=>{
            if(!this.metalPlatForm.includes(item)){
              this.metalPlatForm.push(item);
            }
          })
        }else if(this.option3){
          this.tempList.forEach(item=>{
            if(!this.metalPlatForm2.includes(item)){
              this.metalPlatForm2.push(item);
            }
          })
        }
        this.tempList = [];
        this.sortList();
        //过滤单冠列表中在连桥列表重复数据
        let flattenedArr = this.activeBridgeList.flat();
        this.activeSingleList = this.activeSingleList.filter(num => !flattenedArr.includes(parseInt(num)));
        this.$emit('select-tooth', this.activeSingleList, this.activeBridgeList,this.metalPlatForm,this.metalPlatForm2);
        this.calBridge(this.activeBridgeList)
        this.calJaw()
      }else{
        this.$message({
          message: '请勿重复添加连桥！',
          type: 'error'
        })
      }
      this.firstKey = null
      this.endKey = null
    },
    // 判断连桥相邻牙位
    checkBridge(toothId) {
      console.log("check Bridge ..." + toothId)
      if (this.tempList.length === 0) {
        return true;
      }
      if (
        (this.tempList.includes(18) && (toothId === '28' || toothId === '38' || toothId === '48')) ||
        (this.tempList.includes(28) && (toothId === '18' || toothId === '38' || toothId === '48')) ||
        (this.tempList.includes(38) && (toothId === '18' || toothId === '28' || toothId === '48')) ||
        (this.tempList.includes(48) && (toothId === '18' || toothId === '28' || toothId === '38'))
      ) {
        return false;
      }
      if (
        (toothId === '11' && this.tempList.includes(21)) ||
        (toothId === '21' && this.tempList.includes(11)) ||
        (toothId === '31' && this.tempList.includes(41)) ||
        (toothId === '41' && this.tempList.includes(31))
      ) {
        return true;
      }
      var checkFlag = false;
      for (let i = 0; i < this.tempList.length; i++) {
        if (Math.abs(this.tempList[i] - parseInt(toothId)) === 1) {
          checkFlag = true;
          break;
        }
      }
      return checkFlag;
    },
    // 切换单冠连桥的单选按钮
    changeBridge() {
      this.tempList.forEach((val, i) => {
        this.$refs[this.tempList[i]].setAttribute("class", "tooth-single");
      })
      this.tempList = [];
    },
    sortList() {
      this.tempList.sort();
      this.activeList.sort();
      this.bridgeList.sort();
      this.activeSingleList.sort();
      this.activeBridgeList.sort();
    },
    // 清空连桥
    resetBridge() {
      this.restCss()
      this.tempList.forEach((val, i) => {
        this.$refs[this.tempList[i]].setAttribute("class", "tooth-single");
      })
      this.tempList = [];
      this.bridgeList.forEach((bridgeVal) => {
        this.activeList.forEach((activeVal, i) => {
          if (activeVal === bridgeVal) {
            this.activeList.splice(i, 1)
          }
        })
      })
      this.bridgeList = [];
      this.activeBridgeList = [];
      this.sortList();
      this.$emit('select-tooth', this.activeSingleList, this.activeBridgeList,this.metalPlatForm,this.metalPlatForm2);
    },
    // 清空按钮
    resetSingle(){
      this.restCss()
      this.resetBridge()
      this.tempList.forEach((val, i) => {
        this.$refs[this.tempList[i]].setAttribute("class", "tooth-single");
      })
      this.tempList = [];
      this.bridgeList.forEach((bridgeVal) => {
        this.activeList.forEach((activeVal, i) => {
          if (activeVal === bridgeVal) {
            this.activeList.splice(i, 1)
          }
        })
      })
        this.metalPlatForm = []
        this.metalPlatForm2 = []
        this.activeList = []
        this.activeSingleList = []
      this.sortList();
      this.$emit('select-tooth', this.activeSingleList, this.activeBridgeList,this.metalPlatForm,this.metalPlatForm2);
    },
    // 牙位全选按钮
    selectAll(){
      this.selAll = true
      var all = [18,17,16,15,14,13,12,11,21,22,23,24,25,26,27,28,48,47,46,45,44,43,42,41,31,32,33,34,35,36,37,38];
      var arr = [
        {label:'种植上部修复冠',value:'1010120'},
        {label:'基台设计(金属)',value:'1010210'},
        {label:'基台设计(全瓷)',value:'1010220'},
      ]
      all.forEach((allVal,i)=>{
        if(this.options1&&this.options2){
          this.switchId(arr[0].value,allVal)
          this.switchId(arr[1].value,allVal)
        }else if(this.options1&&this.options3){
          this.switchId(arr[0].value,allVal)
          this.switchId(arr[2].value,allVal)
        }else if(this.options1){
          this.switchId(arr[0].value,allVal)
        }else if(this.options2){
          this.switchId(arr[1].value,allVal)
        }else if(this.options3){
          this.switchId(arr[2].value,allVal)
        }else{
          this.switchId(this.subCatalogId,allVal)
        }
      })
    this.$emit('select-tooth', this.activeSingleList, this.activeBridgeList,this.metalPlatForm,this.metalPlatForm2);
    this.calJaw()
    },
    // 额外适应症选择牙位
    switchId(index,allVal){
      switch(index){
       case '1010120':
       this.ergodic(allVal)
       break;
       case '1010210':
       if(!this.metalPlatForm.includes(allVal)){
        this.metalPlatForm.push(allVal)
       }else if(this.metalPlatForm.includes(allVal)){
        const index = this.metalPlatForm.indexOf(allVal)
        this.metalPlatForm.splice(index,1)
       }
       this.metalPlatForm2 = []
       break;
       case '1010220':
       if(!this.metalPlatForm2.includes(allVal)){
        this.metalPlatForm2.push(allVal)
       }else if(this.metalPlatForm2.includes(allVal)){
        const index = this.metalPlatForm2.indexOf(allVal)
        this.metalPlatForm2.splice(index,1)
       }
       this.metalPlatForm = []
       break;
       case '1010410':
       if(!this.metalPlatForm.includes(allVal)){
        this.metalPlatForm.push(allVal)
       }
      this.metalPlatForm.push(allVal)
       break;
       default:
       this.ergodic(allVal)
       break;
      }
    },
    //selectall调用 遍历
    ergodic(allVal){
      if(this.isBridge == false){
        this.addSingle(allVal)
      }
      if(this.isBridge == true){
        this.addTempBridge(allVal)
      }
    },
    /**
     * 计算上下颌选择牙齿数量
     */
    calJaw() {
      var upData = [18,17,16,15,14,13,12,11,21,22,23,24,25,26,27,28];
      var downData = [48,47,46,45,44,43,42,41,31,32,33,34,35,36,37,38];
      var upSelectCount = 0;
      var downSelectCount = 0;
      var maloUpCount = 0;
      var maloDownCount = 0;
      var metalUp = 0;
      var metalDown = 0;
      for(let i=0;i<upData.length;i++){
        if(this.activeSingleList.includes(upData[i])||this.activeBridgeList.flat().includes(upData[i])){
          upSelectCount++
        }
        if(this.activeSingleList.includes(downData[i])||this.activeBridgeList.flat().includes(downData[i])){
          downSelectCount++
        }
        if(this.metalPlatForm.includes(upData[i])){
          metalUp++
        }
        if(this.metalPlatForm.includes(downData[i])){
          metalDown++
        }
      }
      this.$emit('flagChange',upSelectCount,downSelectCount,metalUp,metalDown)
    },
    // 移除样式
    restCss(){
      this.activeBridgeList.forEach((item,index)=>{
        if(typeof(item)=='string'){
          this.$refs['0'+item].id = ''
          this.$refs['0'+item].setAttribute("class","")
          this.$refs['0'+item].id = ''
          this.$refs['0'+item].setAttribute("class","")
        }else{
          item.forEach((x,y)=>{
            this.$refs['0'+x].id = ''
            this.$refs['0'+x].setAttribute("class","")
            this.$refs['0'+x].id = ''
            this.$refs['0'+x].setAttribute("class","")
          })
        }
      })
    },
    /**
     * 排序，选连桥的时候判断开头和结尾
     */
    calBridge(arr) {
      let fir = [18,17,16,15,14,13,12,11]
      let sec = [21,22,23,24,25,26,27,28]
      let thir = [48,47,46,45,44,43,42,41]
      let four = [31,32,33,34,35,36,37,38]
      let arr1 = []
      let arr2 = []
      let arr3 = []
      let arr4 = []
      arr.forEach((item,index)=>{
          item.forEach((x,y)=>{
            fir.forEach((a,b)=>{
              if(item.includes(a) && !arr1.includes(a)){
                arr1.push(a)
              }
            })
            sec.forEach((a,b)=>{
              if(item.includes(a) && !arr2.includes(a)){
                arr2.push(a)
              }
            })
            thir.forEach((a,b)=>{
              if(item.includes(a) && !arr3.includes(a)){
                arr3.push(a)
              }
            })
            four.forEach((a,b)=>{
              if(item.includes(a) && !arr4.includes(a)){
                arr4.push(a)
              }
            })
          })
          arr1.forEach((a,r)=>{
            if(arr2.length == 0){
              if(r == 0){
                this.$refs['0'+a].setAttribute("id","upper-before")
              }
              if(r+1 == arr1.length){
                 this.$refs['0'+a].setAttribute("id","upper-after")
              }
            }else{
              if(r == 0){
                this.$refs['0'+a].setAttribute("id","upper-before")
              }
            }
          })
          arr2.forEach((a,r)=>{
            if(arr1.length == 0){
              if(r == 0){
                this.$refs['0'+a].setAttribute("id","upper-before")
              }
              if(r+1 == arr2.length){
                 this.$refs['0'+a].setAttribute("id","upper-after")
              }
            }else{
              if(r == arr2.length){
                this.$refs['0'+a].setAttribute("id","upper-after")
              }
            }
          })
          arr3.forEach((a,r)=>{
            if(arr4.length == 0){
              if(r == 0){
                this.$refs['0'+a].setAttribute("id","group-before")
              }
              if(r+1 == arr3.length){
                this.$refs['0'+a].setAttribute("id","group-after")
              }
            }else{
              if(r == 0){
                this.$refs['0'+a].setAttribute("id","upper-before")
              }
            }
          })
          arr4.forEach((a,r)=>{
            if(arr3.length == 0){
              if(r == 0){
                this.$refs['0'+a].setAttribute("id","group-before")
              }
              if(r+1 == arr4.length){
                 this.$refs['0'+a].setAttribute("id","group-after")
              }
            }else{
              if(r == arr4.length){
                this.$refs['0'+a].setAttribute("id","upper-after")
              }
            }
          })
          arr1.splice(0,arr1.length)
          arr2.splice(0,arr2.length)
          arr3.splice(0,arr3.length)
          arr4.splice(0,arr4.length)
        })
    },
    // 处理订单详情回显的连桥显示
    handleBridge(){
      if(this.bridgeDataList&& this.bridgeDataList.length > 0) {
        var str = this.bridgeDataList.join(',');
        let newArray = str.split('/').join(',').split(',');
        let newArray2D = str.split('/').map(str => str.split(','));
        let intArray2D = newArray2D.map(subArray => {
          return subArray.map(str => parseInt(str, 10));
        });
        // 处理订单回显和修改订单连桥传递数据类型不同

        if(Array.isArray(this.bridgeDataList[0])){
          newArray = this.bridgeDataList.join(',').split(',')
          intArray2D = this.bridgeDataList
        }
        if (newArray && newArray.length > 0) {
          newArray.forEach((bridgeData) => {
            if (!this.activeList.includes(parseInt(bridgeData))) {
              this.activeList.push(parseInt(bridgeData))
            }
            this.bridgeList.push(parseInt(bridgeData));
          })
          if(!Array.isArray(this.activeBridgeList[0])){
            this.activeBridgeList.push(newArray)
            this.activeBridgeList = this.activeBridgeList.map(array =>{
              return array.map(str => parseInt(str, 10));
            })
          }else{
            this.activeBridgeList = newArray
          }
          this.calBridge(intArray2D)
        }
      }
    },
    // 详情回显判断额外适应症的牙位
    handleSingle(){
      let arr1 = []
      let arr2 = []
      let arr3 = []
      if (this.singleDataList && this.singleDataList.length > 0) {
       this.singleDataList.forEach((singleData,i) => {
         let str = singleData+''
        if(!str.includes('~')&&!str.includes('^')){
          arr1.push(parseInt(str))
          this.activeSingleList.push(parseInt(singleData))
        }
        if(str.includes('~')){
          arr2.push(parseInt(str.slice(1,3)))
        }
        if(str.includes('^')){
          arr3.push(parseInt(str.slice(1,3)))
        }
       })
        this.activeList = arr1;
        this.metalPlatForm = arr2;
        this.metalPlatForm2 = arr3;
      }
      if(this.bridgeDataList&&this.bridgeDataList.length>0){
        let newArray = this.bridgeDataList.join(',').split(',');
        for(let i=0;i<newArray.length;i++){
          if(newArray[i]!=''){
            arr1.push(parseInt(newArray[i]));
          }
        }
      }
      this.$emit('toothNum',arr1,arr2,arr3);
    },
    // 创建订单显示的连桥牙位处理
    handleCreateOrder(){
      if(this.bridgeDataList&&this.bridgeDataList.length>0){
        let newArray = this.bridgeDataList.join(',').split(',')
        this.activeBridgeList = this.bridgeDataList

        if (newArray && newArray.length > 0) {
          newArray.forEach((bridgeData) => {
            if (!this.activeList.includes(parseInt(bridgeData))) {
              this.activeList.push(parseInt(bridgeData))
            }
          })
        }
        if(this.bridgeDataList&&this.bridgeDataList.length>0&&this.bridgeDataList[0]!=''){
          let arr = this.bridgeDataList.map(subArray=>subArray.join(',')).join(',')
          let init = arr.split(',')
          this.bridgeList = init.map(str=>parseInt(str,10))
          this.calBridge(this.bridgeDataList)
        }
      }
    },
    // 键盘按下/抬起的方法
    handleKeyDown(event) {
      if (event.shiftKey) {
        this.shiftKeyPressed = true;
      }
    },
    handleKeyUp(event) {
      this.shiftKeyPressed = false;
      this.endKey = null
      this.firstKey = null
    },
    // new绑定单机方法
    shiftClickTooth(event){
      let fir = [18,17,16,15,14,13,12,11,21,22,23,24,25,26,27,28]
      let sec = [48,47,46,45,44,43,42,41,31,32,33,34,35,36,37,38]
      let num1 = null
      let num2 = null
      let temp = 0
      if(this.shiftKeyPressed){
        this.clickTooth(event)
        if(fir.includes(parseInt(this.firstKey))){
          fir.forEach((val,i)=>{
            if(val == this.firstKey){
              num1 = i
            }
            if(val == this.endKey){
              num2 = i
            }
          })
        }else{
          sec.forEach((val,i)=>{
            if(val == this.firstKey){
              num1 = i
            }
            if(val == this.endKey){
              num2 = i
            }
          })
        }
        if(num2!=null){
          if(num1>num2){
            temp = num1
            num1 = num2
            num2 = temp
          }
          for (var i= num1 ; i <= num2; i++) {
            if (this.isBridge) {
              if(fir.includes(parseInt(this.firstKey))&&sec.includes(parseInt(this.endKey))){
                this.tempList.forEach((val, i) => {
                  this.$refs[this.tempList[i]].setAttribute("class", "tooth-single");
                })
                this.tempList = []
                return false
              }else if(fir.includes(parseInt(this.firstKey))){
                this.loopAddTemplate(this.tempList,fir[i],true)
              }else if(sec.includes(parseInt(this.firstKey))){
                this.loopAddTemplate(this.tempList,sec[i],true)
              }
            }else{
              let id = this.subCatalogId
              if(id == '1010210'){
                if(fir.includes(parseInt(this.firstKey))){
                  this.loopAddTemplate(this.metalPlatForm,fir[i],false)
                }else if(sec.includes(parseInt(this.firstKey))){
                  this.loopAddTemplate(this.metalPlatForm,sec[i],false)
                }
                if(this.options1){
                  if(fir.includes(parseInt(this.firstKey))){
                    this.loopAddTemplate(this.activeList,fir[i],false)
                    this.loopAddTemplate(this.activeSingleList,fir[i],false)
                  }else if(sec.includes(parseInt(this.firstKey))){
                    this.loopAddTemplate(this.activeList,sec[i],false)
                    this.loopAddTemplate(this.activeSingleList,sec[i],false)
                  }
                }
              }else if(id == '1010220'){
                if(fir.includes(parseInt(this.firstKey))){
                  this.loopAddTemplate(this.metalPlatForm2,fir[i],false)
                }else if(sec.includes(parseInt(this.firstKey))){
                  this.loopAddTemplate(this.metalPlatForm2,sec[i],false)
                }
                if(this.options1){
                  if(fir.includes(parseInt(this.firstKey))){
                    this.loopAddTemplate(this.activeList,fir[i],false)
                    this.loopAddTemplate(this.activeSingleList,fir[i],false)
                  }else if(sec.includes(parseInt(this.firstKey))){
                    this.loopAddTemplate(this.activeList,sec[i],false)
                    this.loopAddTemplate(this.activeSingleList,sec[i],false)
                  }
                }
              }else if(id == '1010410'){
                if(this.options1){
                  if(fir.includes(parseInt(this.firstKey))){
                    this.loopAddTemplate(this.activeList,fir[i],false)
                    this.loopAddTemplate(this.activeSingleList,fir[i],false)
                  }else if(sec.includes(parseInt(this.firstKey))){
                    this.loopAddTemplate(this.activeList,sec[i],false)
                    this.loopAddTemplate(this.activeSingleList,sec[i],false)
                  }
                }else{
                  if(fir.includes(parseInt(this.firstKey))){
                    this.loopAddTemplate(this.metalPlatForm,fir[i],false)
                    // this.loopAddTemplate(this.activeList,fir[i],false)
                    // this.loopAddTemplate(this.activeSingleList,fir[i],false)
                  }else if(sec.includes(parseInt(this.firstKey))){
                    this.loopAddTemplate(this.metalPlatForm,sec[i],false)
                    // this.loopAddTemplate(this.activeList,sec[i],false)
                    // this.loopAddTemplate(this.activeSingleList,sec[i],false)
                  }
                }
              }else{
                if(fir.includes(parseInt(this.firstKey))){
                  this.loopAddTemplate(this.activeList,fir[i],false)
                  this.loopAddTemplate(this.activeSingleList,fir[i],false)
                }else if(sec.includes(parseInt(this.firstKey))){
                  this.loopAddTemplate(this.activeList,sec[i],false)
                  this.loopAddTemplate(this.activeSingleList,sec[i],false)
                }
              }
              this.judgeFlag(fir,sec,fir[i],sec[i])
            }
          }
        }
      }else{
        this.clickTooth(event)
      }
      this.$emit('select-tooth', this.activeSingleList, this.activeBridgeList,this.metalPlatForm,this.metalPlatForm2);
    },
    // 上面方法中调用循环模版
    loopAddTemplate(list,item,flag){
      list.forEach(val=>{
        if(val!=item&&!list.includes(item)){
          if(flag){
            this.$refs[item].setAttribute("class","tooth-select");
          }
          list.push(item)
        }
      })
      if(this.activeBridgeList.length>0){
        this.activeBridgeList.forEach(val=>{
          val.forEach(item=>{
            if(this.activeSingleList.includes(item)){
              const index = this.activeSingleList.indexOf(item)
              this.activeSingleList.splice(index,1)
            }
          })
        })
      }
    },
    // 判断基台对应状态
    judgeFlag(fir,sec,firVal,secVal){
      if(this.options2){
        if(fir.includes(parseInt(this.endKey))){
          this.loopAddTemplate(this.metalPlatForm,firVal,false)
        }else if(sec.includes(parseInt(this.endKey))){
          this.loopAddTemplate(this.metalPlatForm,secVal,false)
        }
        this.metalPlatForm.forEach(val=>{
          if(this.metalPlatForm2.includes(val)){
            const index = this.metalPlatForm2.indexOf(parseInt(val))
            this.metalPlatForm2.splice(index,1)
          }
        })
      }else if(this.options3){
        if(fir.includes(parseInt(this.endKey))){
          this.loopAddTemplate(this.metalPlatForm2,firVal,false)
        }else if(sec.includes(parseInt(this.endKey))){
          this.loopAddTemplate(this.metalPlatForm2,secVal,false)
        }
        this.metalPlatForm2.forEach(val=>{
          if(this.metalPlatForm.includes(val)){
            const index = this.metalPlatForm.indexOf(parseInt(val))
            this.metalPlatForm.splice(index,1)
          }
        })
      }
    },
  },
  mounted() {
    // 监听键盘按键shift
    window.addEventListener('keydown',this.handleKeyDown)
    window.addEventListener('keyup',this.handleKeyUp)
    // 刷新回显单冠牙位处理
    this.handleSingle()
    // 判断建单还是回显进入
    if(this.isCreate){
      // 刷新显示创建订单显示的连桥牙位的处理
      this.handleCreateOrder()
    }else{
      // 处理订单详情的连桥显示
      this.handleBridge()
    }
    this.sortList()
    this.metalPlatForm = sessionStorage.getItem('metal')?JSON.parse(sessionStorage.getItem('metal')):this.metalPlatForm;
    this.metalPlatForm2 = sessionStorage.getItem('metal2')?JSON.parse(sessionStorage.getItem('metal2')):this.metalPlatForm2;
    if(this.subCatalogId=='1010510'){
      this.isBridge = true
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);
  },
 }
</script>

<style lang="scss">
  .tooth-wrap {
    padding: 10px;
    display: flex;
    flex-direction: row;
    position: relative;
  }

  .tooth-table {
    font-size: 0;

    img {
      height: 60px;
      margin: 0px;
      display: inline-block;
    }

  }

  .tooth-table-show {
    font-size: 0;

    img {
      height: 50px;
      margin: 0px;
      display: inline-block;
    }

  }

  .tooth-select {
    border-radius: 5px;
    background-color: #E4E7ED;
  }
  .tooth-act-sel {
    border-radius: 5px;
    background-color: rgba(109, 194, 247,0.3);
  }
  .tooth-bridge {
    border-top: 2px solid rgba(109, 194, 247, 0.000);
  }
  .tooth-single {
    border-top: 2px solid rgba(109, 194, 247, 0.000);
  }
  .bridge-col {
    background-color:rgb(109, 194, 247) ;
  }
  #upper-before::before{
    content: '-';
    margin-top:-19px;
    float: left;
    color: rgb(247, 247, 247);
    // color:red;
    font-weight:200;
    font-size:30px;
  }
  #upper-after::after{
    content: '-';
    margin-top:-19px;
    float: right;
    color: rgb(247, 247, 247);
    font-weight:200;
    font-size:30px;
  }

  #group-before::before{
    float: left;
    color: rgb(247, 247, 247);
    content: '-';
    font-weight:200;
    font-size:30px;
    margin-top:-19px;
  }
  #group-after::after{
    float: right;
    color: rgb(247, 247, 247);
    content: '-';
    font-weight:200;
    font-size:30px;
    margin-top:-19px;
  }

  .radio-wrap,
  .button-wrap,
  .button-add,
  .button-clear {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .button-add .el-button--primary.is-plain {
    color: #00a5d5;
    background: rgba(109, 194, 247, 0.000);
    border-color: #00a5d5;
  }

  .button-clear .el-button--primary.is-plain {
    color: #666666;
    background: rgba(109, 194, 247, 0.000);
    border-color: #666666;
  }

  .radio-wrap img {
    flex: 1;
    width: 32px;
  }

  .el-radio {
    color: #666666;
    cursor: pointer;
    margin: 10px 0;
    margin-right: 20px;
  }

  .radio-wrap .el-radio {
    margin-right: 0;
    margin-left: -20px;
  }

  .el-radio__label {
    font-size: 13px;
    padding-left: 10px;
  }

  .el-radio__input.is-checked+.el-radio__label {
    color: #00a5d5;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: #00a5d5;
    background: #00a5d5;
  }

  .el-radio__inner:hover {
    border-color: #00a5d5;
  }

  .btn-pos{
	margin-top: 5px;
	margin-left: 0px !important;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
  }

  tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
  }
  .bridge-col-add{
	opacity: 1;
  }
  .bridge-col-zero{
  	opacity: 0;
  }
  .lab-cen{
	margin-left: 32%;
  }
  .porcelain{
	  color: #2ed573;
  }

</style>;



// WEBPACK FOOTER //
// YTooth.vue?3c3a6cac